import { JsonObject, JsonProperty } from "ta-json";

import Resource from "./resource";

@JsonObject()
export default class SetPasswordRequestResource extends Resource {
    @JsonProperty("password")
    password: string;

    constructor(password: string) {
        super();
        this.password = password;
    }
}

export { SetPasswordRequestResource };
